import { ProData } from '../../../shared/types';
import { isPaulHoodReferral } from '../../../shared/utils';

function shouldReceivePHQuestionsFlow(proInfo: ProData): boolean {
  return isPaulHoodReferral(proInfo.account_key);
}

export { shouldReceivePHQuestionsFlow };
